/**
 * Доступ к тосту приложения вне компонентов — например, из guard'а роутера.
 *
 * Тост живёт в корневом layouts/App.vue и регистрируется здесь при его монтировании.
 * Достать его через `__vue_app__._instance` нельзя: в production-сборке Vue это поле
 * не заполняет, и сообщение молча пропадало бы.
 *
 * При открытии закрытой ссылки напрямую guard срабатывает до монтирования App.vue —
 * такие сообщения копятся и показываются сразу после регистрации тоста.
 */
let toast = null
const pending = []

export function registerAppToast(instance) {
  toast = instance
  while (pending.length > 0) {
    toast?.error?.(pending.shift())
  }
}

export function appToastError(message) {
  if (toast) {
    toast.error?.(message)
    return
  }
  pending.push(message)
}
